<template>
    <div>
        <div class="
                align-items-center
                border-grey
                qu-fc-color
                cursor-pointer
                mr-0
            " v-b-modal.webPreviewQuestions :class="{ disabled: questions.length <= 0 }"
            @click.prevent="questions.length > 0" style="margin-left: 5px;">
            <span>Web Preview</span>
        </div>

        <b-modal id="webPreviewQuestions" ref="webPreviewQuestions" hide-footer size="lg" centered>
            <template #modal-title>
                <div class="
                        d-flex
                        flex-row
                        align-items-center
                        justify-content-between
                        w-100
                    ">
                    <div class="d-flex flex-row align-items-center">
                        <span>Web Preview Questions</span>
                        <span class="ml-1" v-if="levelName">Level {{ levelName }}</span>
                    </div>
                    <div style="position: absolute; right: 60px">
                        <feather-icon v-if="isLandscape" icon="RotateCwIcon" size="20" @click="toggleOrientation"
                            style="cursor: pointer" />
                        <feather-icon v-else icon="RotateCcwIcon" size="20" @click="toggleOrientation"
                            style="cursor: pointer" />
                    </div>
                </div>
            </template>

            <div class="modal_content">
                <div v-if="questions.length > 0" style="position: relative">
                    <div v-if="renderIframeUrl" class="question-container" style="
                            position: relative;
                            justify-content: center;
                            align-items: center;
                        ">
                        <iframe :src="renderIframeUrl" :width="isLandscape ? 932 : 430"
                            :height="isLandscape ? 430 : 932" title="Web Preview Questions"></iframe>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { BButton, BAlert, BSpinner } from "bootstrap-vue";

export default {
    components: {
        BButton,
        BAlert,
        BSpinner,
    },
    props: {
        questions: Array,
        showLevelCompletedModel: Function,
        levelName: [String, Number],
        token: String,
    },
    data() {
        return {
            bearerToken: null,
            isLandscape: true,
            userId:null
        };
    },
    computed: {
        renderIframeUrl() {
            const baseUrl = process.env.VUE_APP_NEXT_WEB_PREVIEW || 'https://zape-web-app-01.barqsol.com/?';
            const levelId = this.$route.params.levelId;
            const userId = this.userId;

            if (this.bearerToken) {
                const fullUrl = `${baseUrl}level=${levelId}&platform=web&user=${userId}&token=${this.bearerToken}`;
                return fullUrl;
            }
            return "";
        },
    },
   mounted() {
    this.bearerToken = localStorage.getItem("_t");
    const userdataStr = localStorage.getItem("Datauser");
    if (userdataStr) {
        const userdata = JSON.parse(userdataStr);
        this.userId = userdata.user._id;
    }
},

    methods: {
        toggleOrientation() {
            this.isLandscape = !this.isLandscape;
        },
    },
};
</script>

<style scoped>
#webPreviewQuestions .modal-footer,
#webPreviewQuestions .modal-body {
    padding: unset;
}

.cursor-pointer {
    cursor: pointer;
}

#add-questions-modal .card-body {
    padding: 0px;
}

.curser-pointer {
    cursor: pointer;
}

ol {
    list-style-type: lower-alpha;
}

#webPreviewQuestions .modal-content {
    background-image: url("../../../../public/Scene_Default.jpg");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    border-radius: 8px;
    color: white;
}

.question-container {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
}

.question-number {
    position: absolute;
    right: 10px;
    top: 10px;
    background-color: white;
    border-radius: 10px;
    padding: 5px 10px;
    font-size: 12px;
    color: #333;
}

.prev-icon img {
    width: 45px;
}

#webPreviewQuestions .modal-footer {
    padding: unset;
}

#webPreviewQuestions .modal-body {
    padding: unset;
}

input[type="checkbox"] {
    width: 35px;
    height: 35px;
    border-radius: 50% !important;
    flex: 0 0 15%;
}

.checkbox-group span {
    color: black;
    font-weight: bold;
    text-align: center;
    width: 80%;
    max-width: 80%;
    font-size: 33px;
}

.option-list {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 10px;
    padding-bottom: 50px !important;
    justify-content: center;
    align-items: center;
}

.two-images-option-list {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 50px;
    padding-bottom: 70px !important;
    justify-content: center;
    align-items: center;
}

.option-item {
    padding: 10px;
    border-radius: 5px;
    color: white;
    flex: 1 1 150px;
    text-align: center;
}

.two-images-option-item {
    width: 270px !important;
    height: 270px !important;
    background-color: white;
    padding: 10px;
    border-radius: 5px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    align-self: center;
}

.two-images-option-item img {
    width: 180px;
}

.next-icon img {
    width: 45px;
}

#webPreviewQuestions .question-title {
    max-width: 80%;
    margin-bottom: 20px;
    text-align: center;
    align-self: center;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    background-color: #0d5cab;
    display: inline-block;
    padding: 20px 25px;
    color: white;
    cursor: pointer;
}

.checkbox-group {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    width: 100%;
    border-radius: 10px;
    padding-top: 13px;
    padding-bottom: 10px;
}

[dir] .modal-footer {
    border-top: 1px solid rgb(247 247 247 / 37%);
}

.circle-checkbox-container {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: center;
    background: #fff;
    border-radius: 6px;
    overflow: hidden;
    position: relative;
    min-height: 75px;
    margin-bottom: 23px;
}

.checkbox-col {
    width: 65px;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.checkbox-title {
    flex: 1;
    text-align: center;
    overflow-wrap: break-word;
    word-break: break-word;
    padding-left: 65px;
    font-size: 25px;
    height: 100%;
    font-weight: bold;
}

.disabled {
    pointer-events: none;
    opacity: 0.5;
    cursor: not-allowed;
}
</style>
